<template>


  <div class="grid-main bg-purple ">
    <h2 style="float: left">超投列表</h2>
	<button type="button" class="el-button el-button--primary" @click="exportExcel"><!----><!----><span>导出为表格</span></button>
    <div class="table-box" >

      <el-table
        :data="scoreList.list"
        height="550"
        border
        style="width: 100%;">
		<el-table-column
		  prop="imgUrl"
		  label="现场图片(点击可以放大)"
		  width="180">
		 <template slot-scope="scope">
		     <img :src="scope.row.imgUrl" alt="" style="width: 30px;" @click="openPreview(scope.row.imgUrl)"/>
			 <!-- <a :href="scope.row.imgUrl">下载</a> -->
		   </template>
		</el-table-column>
        <el-table-column
          prop="vehicleNum"
          label="车辆编码"
          width="180">
        </el-table-column>
		<el-table-column
		  prop="type"
		  label="违规类型"
		  width="180">
		</el-table-column>
		<el-table-column
		  prop="address"
		  label="事件位置"
		  width="280">
		</el-table-column>
		<el-table-column
		  prop="operatorNum"
		  label="违规企业"
		  width="180">
		 <template slot-scope="scope">
		     <!-- 根据 operatorNum 显示对应的企业名称 -->
		     <span>{{ mapOperatorNumToName(scope.row.operatorNum) }}</span>
		   </template>
		</el-table-column>
        <el-table-column
          prop="dateTime"
          label="时间"
          width="220">
        </el-table-column>


    <!--    <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openscore(scope.row.scoreItemId)">编辑</el-button>
            <el-button

              size="mini"
              type="danger"
              @click="openDelete(scope.row.scoreItemId)">删除</el-button>

          </template>
        </el-table-column> -->

      </el-table>
      <el-pagination
      	v-if="scoreList.scoreListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="scoreList.scorepageSize"
        @current-change="setselectscorelist"
        :total="scoreList.scoreListtotal">

      </el-pagination>
    </div>



	<!-- 预览遮罩层 -->
	    <div 
	      v-if="isPreviewOpen" 
	      class="preview-overlay" 
	      @click="closePreview"
	    >
	      <img 
	        :src="imageUrl" 
	        alt="大图预览" 
	        class="preview-content"
	      >
	    </div>
  </div>
</template>

<script>
export default {
  name: "Chaotou_list",
  data(){
    return {
		imageUrl:'',
		isPreviewOpen: false, // 预览是否打开
      //指标项
      scoreList:{
        list:[],
        scoreListpage:1,
        scoreListtotal:0,
        scorepageSize:10
      },
      //新增指标项
      scoreItemAdds:{
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      },
      dialogscoreAdd:false,
      scoreTypeSelectAll:{},
      ScoreItemAll:{},
      dialogupdatscore:false,
      updatescoreItem:{
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      },


    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.selectscorelist();
    this.selectscoreTypeSelectAll();
	
	
	// this.exportExcel();
	
  },
  methods: {
	  
	  openPreview(url) {
		  this.imageUrl = url;
	        this.isPreviewOpen = true;
	        document.body.style.overflow = 'hidden'; // 防止背景滚动
	      },
	      closePreview() {
	        this.isPreviewOpen = false;
	        document.body.style.overflow = ''; // 恢复背景滚动
	      },
	  
    dialogrolscoreclose(){
      this.dialogupdatscore=false;
      this.updatescoreItem={
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      };
      this.dialogscoreAdd=false
      this.scoreItemAdds={
        scoreTypeId:'',
        scoreItem:'',
        needFile:1,
        scoreValue:'',
        description:'',
      };
    },
    //考核项

    selectscorelist(){
      let that = this;
      let scoredata = {
        page:this.scoreList.scoreListpage,
        pageSize:this.scoreList.scorepageSize
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/vehicle/his/validated',scoredata)
        .then(function (res) {

          if(res.data.code==200){
            that.scoreList.list = res.data.data.list;
            that.scoreList.scoreListtotal = res.data.data.total;
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    setselectscorelist(scoreListpage){
      this.scoreList.scoreListpage = scoreListpage;
      this.selectscorelist();
    },

    //新增考核项
    scoreItemAdd(){
      let that = this;

      if (that.scoreItemAdds.scoreTypeId == '') {
        that.$message.error('请选择指标类别');
        return false;
      }
      if (that.scoreItemAdds.scoreItem == '') {
        that.$message.error('请输入指标项名称');
        return false;
      }
      if (that.scoreItemAdds.scoreValue == '') {
        that.$message.error('请输入指标项分值');
        return false;
      }
      if (that.scoreItemAdds.description == '') {
        that.$message.error('请输入分值及计算方式');
        return false;
      }
      let scoreItemdata = {
        scoreTypeId:that.scoreItemAdds.scoreTypeId,
        scoreItem:that.scoreItemAdds.scoreItem,
        needFile:that.scoreItemAdds.needFile,
        scoreValue:that.scoreItemAdds.scoreValue,
        description:that.scoreItemAdds.description,
      }
      this.$axios
        .post('/api/scoreItem/scoreItemAdd', scoreItemdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增指标项失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增指标项成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
    selectscoreTypeSelectAll(){
      let that = this;
      this.$axios
        .get('/api/scoreType/scoreTypeSelectAll')
        .then(function (res) {
          if(res.data.code == 200){
            that.scoreTypeSelectAll = res.data.data;

          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    selectScoreItemById(){

      let that = this;

      let updatescoreItemiddata = {
        id:that.scoreId
      }
      this.$axios
        .post('/api/scoreItem/selectScoreItemById', updatescoreItemiddata)
        .then(function (res) {
          that.updatescoreItem.scoreTypeId=res.data.data.scoreTypeId;
          that.updatescoreItem.scoreItem=res.data.data.scoreItem;
          that.updatescoreItem.needFile=res.data.data.needFile;
          that.updatescoreItem.scoreValue=res.data.data.scoreValue;
          that.updatescoreItem.description=res.data.data.description;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    openscore(scoreId){

      this.scoreId = scoreId;

      this.selectScoreItemById();
      window.setTimeout(() => {
        this.dialogupdatscore = true;
      },100);


    },
    //修改企业信息
    updatescore(){
      let that = this;
      if (that.updatescoreItem.scoreTypeId == '') {
        that.$message.error('请选择指标类别');
        return false;
      }
      if (that.updatescoreItem.scoreItem == '') {
        that.$message.error('请输入指标项名称');
        return false;
      }
      if (that.updatescoreItem.scoreValue == '') {
        that.$message.error('请输入指标项分值');
        return false;
      }
      if (that.updatescoreItem.description == '') {
        that.$message.error('请输入分值及计算方式');
        return false;
      }

      let updatescoreItemdata = {
        scoreItemId:that.scoreId,
        scoreTypeId:that.updatescoreItem.scoreTypeId,
        scoreItem:that.updatescoreItem.scoreItem,
        needFile:that.updatescoreItem.needFile,
        scoreValue:that.updatescoreItem.scoreValue,
        description:that.updatescoreItem.description,
      }
      this.$axios
        .post('/api/scoreItem/updateScoreItem', updatescoreItemdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改指标项失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改指标项成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },



    openDelete(scoreId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteScoreItem(scoreId)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除企业信息
    deleteScoreItem(scoreId){
      let that = this;
      let scoreIds = {
        scoreItemIds:[]
      }
      scoreIds.scoreItemIds.push(scoreId);
      this.$axios
        .post('/api/scoreItem/batchDeleteScoreItem',scoreIds)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
	 mapOperatorNumToName(operatorNum) {
	    // 根据 operatorNum 返回对应的企业名称
	    const operatorMap = {
	      'MT': '美团',
	      'HL': '哈罗',
	      'DD': '青桔',
	      // 更多映射...
	    };
	    return operatorMap[operatorNum] || '未知企业';
	  },
	  
	  exportExcel(){
		// 手动加入js
		var url ="https://g.alicdn.com/code/lib/xlsx/0.18.5/xlsx.mini.min.js";
		//创建一个 script dom元素
		// doc需要补全document
		var jsapi = document.createElement("script");
		//设定script标签属性
		jsapi.charset = "utf-8";
		jsapi.src = url;
		document.head.appendChild(jsapi);
		
		let scoredata = {
		  page:1,
		  pageSize:1111111
		}
		this.$axios.defaults.withCredentials=true;
		this.$axios
		  .post('/api/vehicle/his/validated',scoredata)
		  .then(function (res) {
		
		    if(res.data.code==200){
		      console.log(res.data.data.list);
			  // 导出对应的表格
			  const data = res.data.data.list;
			  const ws = XLSX.utils.json_to_sheet(data);
			  const wb = XLSX.utils.book_new();
			  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
			  XLSX.writeFile(wb, "export.xlsx");
			  
		    }else{
		      that.$message.error(res.data.msg);
		    }
		  }).catch(function (error) { // 请求失败处理
		  console.log("服务器错误"+error);
		});
		
	  }
  },
  watch: {

  },
}
</script>

<style scoped>
.preview-image {
  cursor: zoom-in;
  max-width: 100%;
}

.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.preview-content {
  max-width: 90%;
  max-height: 90%;
  cursor: zoom-out;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/chaotou_list.vue